import React from 'react'
import PropTypes from 'prop-types'
import { Modal as SemanticUiModal } from 'semantic-ui-react'
import { Toggle } from 'react-powerplug'

export class RenderModal extends React.Component {
  constructor(props) {
    super(props)
    const { Provider, Consumer } = React.createContext()
    this.Provider = Provider
    this.Consumer = Consumer
  }

  Modal = ({ children, ...props }) => (
    // eslint-disable-next-line no-undef
    <this.Consumer>
      {({ open, setOpen }) => (
        <SemanticUiModal open={open} onClose={() => setOpen(false)} {...props}>
          {children}
        </SemanticUiModal>
      )}
    </this.Consumer>
  )

  render() {
    const { children } = this.props

    return (
      <Toggle>
        {({ on, set }) => (
          // eslint-disable-next-line no-undef
          <this.Provider value={{ open: on, setOpen: set }}>
            {children({ Modal: this.Modal, open: () => set(true), close: () => set(false) })}
          </this.Provider>
        )}
      </Toggle>
    )
  }
}

RenderModal.propTypes = {
  children: PropTypes.func,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RenderModal/index.js